import programs from "./programs";

export const host = {
    programs,
};

export default host;
